// This script defines a custom HTML element 'modal-trigger' that opens a modal when clicked.

console.log("JS loaded");

customElements.define('modal-trigger', class ModalTrigger extends HTMLElement {

  constructor () {
    // Inherit parent class properties
    super();

    this.btn = this.querySelector('a');
  }
  
  get modalId() {
    return this.btn.getAttribute('data-modal-name');
  }
	
  openModal(modalId) {
    
    const modal = document.getElementById(modalId);

    console.log(modal);

    if (modal) {
      // modal.classList.toggle('modal-content__modal--active');

      if(modal.classList.contains('modal-content__modal--active')) {
          close()
      } else {
          open();
      }

      function open() {
        modal.classList.add("modal-content__modal--active");
        modal.classList.add("--animate");
        setTimeout(() => {
          modal.querySelector(".modal-content__modal-box").classList.remove("modal-content__modal-box--hidden");
        }, 300);
      }
      
      function close() {
        modal.classList.remove("--animate");
        modal.querySelector(".modal-content__modal-box").classList.add("modal-content__modal-box--hidden");
        
        setTimeout(() => {
          modal.classList.remove("modal-content__modal--active");
        }, 300);
      }

    } else {
      console.error(`Modal with id ${modalId} not found`);
    }
  }

  connectedCallback () {
    this.btn.addEventListener('click', () => this.openModal(this.modalId));
  }
});

function handleVideoVisibility() {
  const videos = document.querySelectorAll('video');

  if (!videos.length) {
    return;
  }
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }, { threshold: 0.5 }); // 50% of the video needs to be visible

  videos.forEach(video => {
    observer.observe(video);
  });
}

// Call the function when the page loads
document.addEventListener('DOMContentLoaded', handleVideoVisibility);

// Toggle mobile menu

function toggleMenu() {
  const menu = document.querySelector('.header__nav--mobile');
  const body = document.body;
  menu.classList.toggle('--is-open');
  
  // Toggle body scroll
  
  if (menu.classList.contains('--is-open')) {
    body.style.overflow = 'hidden';
  } else {
    body.style.overflow = '';
  }
}

document.querySelector('#header__nav-toggle').addEventListener('click', (e) => {
  e.preventDefault();
  toggleMenu();
  const button = e.target;
  button.textContent = button.textContent === 'Menu' ? 'Close' : 'Menu';
});